import React, { useState, useEffect } from 'react';
import { TableContainer } from '@mui/material';
import moment from 'moment';
import QRCode from 'react-qr-code'; 
import { useApi } from '../ContextApi/ContextApi';
import '../UI/Template.css';

const Template4 = ({ reportData = [], QRurl }) => {
  const [FontStyle, setFontStyles] = useState([]);
  const [DRS, setDRS] = useState([]);

  const currentDateTime = new Date();
  const formattedCurrentDate = moment(currentDateTime).format('D MMM YYYY, h:mm A');
  const username = (sessionStorage.getItem("FirstName") || "") + " " + (sessionStorage.getItem("LastName") || "");
  const { Comment, isheader } = useApi();

  const groupByCategoryAndSubCategory = (data) => {
    return data.reduce((result, item) => {
      const category = item.categorY_CODE;
      const subCategory = item.suB_CATEGORY_CODE;

      if (!result[category]) {
        result[category] = {
          categoryValue: item.categorY_VALUE,
          subCategories: {},
        };
      }

      if (!result[category].subCategories[subCategory]) {
        result[category].subCategories[subCategory] = {
          subCategoryValue: item.suB_CATEGORY_VALUE,
          items: [],
        };
      }

      result[category].subCategories[subCategory].items.push(item);
      return result;
    }, {});
  };

  const groupedData = groupByCategoryAndSubCategory(reportData);

  const formatTextWithLineBreaks = (text) => {
    if (!text) return '-';
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  useEffect(() => {
    try {
      const styles = JSON.parse(localStorage.getItem('FontStyle'));
      if (styles) setFontStyles(styles);
    } catch (e) {
      console.error("Failed to parse FontStyle", e);
    }
  }, []);

  const image = localStorage.getItem('LogoImage');
  const LabName = reportData.find((x) => x.laboratoryName !== '' && x.laboratoryName != null)?.laboratoryName || "Diagnostic Laboratory";

  const Resultcalculation = (range, result) => {
    if (!range || result === undefined || result === null) return '#1e293b';
    const [min, max] = range.split('-').map(Number);
    if (isNaN(min) || isNaN(max)) return '#1e293b';

    const numResult = Number(result);
    if (numResult < min) return '#2563eb'; // Modern Blue for Low
    if (numResult > max) return '#dc2626'; // Modern Red for High
    return '#1e293b'; // Slate dark for Normal
  };

  const Getlowhighvalue = (range, result) => {
    if (!range || result === undefined || result === null) return '';
    const [min, max] = range.split('-').map(Number);
    if (isNaN(min) || isNaN(max)) return '';

    const numResult = Number(result);
    if (numResult < min) return ' (Low)';
    if (numResult > max) return ' (High)';
    return '';
  };

  const patient = reportData?.[0] || {};
  const fontFamily = FontStyle[0]?.fontfamily || 'Inter, -apple-system, sans-serif';
  const baseFontSize = FontStyle[0]?.fontsize || '12px';

  return (
    <div className="print-report" style={{ fontFamily, fontSize: baseFontSize, padding: '20px' }}>
      <div className="page" style={{ background: '#ffffff', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
        
        {/* Header Section */}
        <header className="print-header" style={{ marginBottom: '24px' }}>
          {isheader && image && (
            <div style={{ textAlign: 'center', marginBottom: '20px', borderBottom: '2px solid #e2e8f0', pb: '16px' }}>
              <img
                className="logo-img"
                src={`data:image/png;base64,${image}`}
                alt="Lab Logo"
                style={{ maxHeight: '100px', objectFit: 'contain' }}
              />
            </div>
          )}

          {/* Patient Details Card */}
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr', gap: '16px', background: '#f1f5f9', padding: '16px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <span style={{ fontSize: '18px', fontWeight: '700', color: '#0f172a' }}>{patient.patientName || 'N/A'}</span>
              <span style={{ color: '#64748b', fontSize: '11px' }}>
                <strong>MR No:</strong> <span style={{ color: '#0f172a' }}>{patient.patientID || 'N/A'}-{sessionStorage.getItem('LabID') || ''}</span>
              </span>
              <span style={{ color: '#64748b', fontSize: '11px' }}>
                <strong>{patient.sex?.toLowerCase() === 'male' ? 'Father Name:' : 'Father / Husband:'}</strong> <span style={{ color: '#0f172a' }}>{patient.guardianName || '-'}</span>
              </span>
              <span style={{ color: '#64748b', fontSize: '11px' }}>
                <strong>Age / Gender:</strong> <span style={{ color: '#0f172a' }}>{patient.age} Y / {patient.sex}</span>
              </span>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {QRurl && <QRCode value={QRurl} size={70} style={{ borderRadius: '6px' }} />}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', textAlign: 'right' }}>
              <span style={{ color: '#64748b', fontSize: '11px' }}>
                <strong>Collected At:</strong> <span style={{ color: '#0f172a' }}>{patient.address || 'Main Branch'}</span>
              </span>
              <span style={{ color: '#64748b', fontSize: '11px' }}>
                <strong>Phone:</strong> <span style={{ color: '#0f172a' }}>{patient.contactNumber || '-'}</span>
              </span>
              <span style={{ color: '#64748b', fontSize: '11px' }}>
                <strong>Referred By:</strong> <span style={{ color: '#0f172a' }}>{patient.referredBy || 'Self'}</span>
              </span>
              <span style={{ color: '#64748b', fontSize: '11px' }}>
                <strong>Registered On:</strong> <span style={{ color: '#0f172a' }}>{patient.createdAt ? moment(patient.createdAt).format('D MMM YYYY') : '-'}</span>
              </span>
            </div>
          </div>
        </header>

        {/* Results Section */}
        <main className="report-body">
          {Object.keys(groupedData).map((category, index) => (
            <div className="category-section" key={index} style={{ marginBottom: '24px' }}>
              
              {/* Category Header */}
              <div style={{ background: '#0284c7', color: '#ffffff', padding: '8px 16px', borderRadius: '6px', fontWeight: '700', fontSize: '20px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {groupedData[category].categoryValue}
              </div>

              {Object.keys(groupedData[category].subCategories).map((subCategory, subIndex) => (
                <div key={subIndex} style={{ marginTop: '12px' }}>
                  {groupedData[category].subCategories[subCategory].subCategoryValue && (
                    <div style={{ fontWeight: '600', color: '#334155', padding: '4px 8px', fontSize: '12px', borderLeft: '3px solid #0284c7', marginBottom: '8px' }}>
                      {groupedData[category].subCategories[subCategory].subCategoryValue}
                    </div>
                  )}

                  <TableContainer style={{ boxShadow: 'none', background: 'transparent' }}>
                    <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', marginTop: '4px' }}>
                      <thead>
                        <tr style={{ background: '#f8fafc', borderBottom: '2px solid #cbd5e1' }}>
                          <th style={{ textAlign: 'left', padding: '10px', color: '#475569', fontWeight: '700', width: '40%', borderBottom: '2px solid #e2e8f0' }}>Investigation</th>
                          <th style={{ textAlign: 'left', padding: '10px', color: '#475569', fontWeight: '700', width: '20%', borderBottom: '2px solid #e2e8f0' }}>Result</th>
                          <th style={{ textAlign: 'left', padding: '10px', color: '#475569', fontWeight: '700', width: '20%', borderBottom: '2px solid #e2e8f0' }}>Unit</th>
                          <th style={{ textAlign: 'left', padding: '10px', color: '#475569', fontWeight: '700', width: '20%', borderBottom: '2px solid #e2e8f0' }}>Reference Range</th>
                        </tr>
                      </thead>
                      <tbody>
                        {groupedData[category].subCategories[subCategory].items.map((data, itemIdx) => {
                          const resultColor = Resultcalculation(data.normalRange, data.testResult);
                          const flag = Getlowhighvalue(data.normalRange, data.testResult);
                          const isOdd = itemIdx % 2 === 0;

                          return (
                            <tr key={itemIdx} style={{ background: isOdd ? '#ffffff' : '#f8fafc', transition: 'background 0.2s' }}>
                              <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9', color: '#1e293b', fontWeight: '500' }}>
                                {data.testName}
                              </td>
                              <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9', fontWeight: '700', color: resultColor }}>
                                {data.testResult}
                                {flag && (
                                  <span style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '4px', marginLeft: '6px', background: flag.includes('High') ? '#fee2e2' : '#dbeafe', color: resultColor }}>
                                    {flag.trim()}
                                  </span>
                                )}
                              </td>
                              <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9', color: '#64748b' }}>
                                {formatTextWithLineBreaks(data.unit)}
                              </td>
                              <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9', color: '#64748b' }}>
                                {formatTextWithLineBreaks(data.normalRange)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </TableContainer>
                </div>
              ))}
            </div>
          ))}
        </main>

        {/* Footer Section */}
        <footer className="print-footer" style={{ marginTop: '32px', paddingTop: '16px', borderTop: '2px solid #e2e8f0' }}>
          {Comment && (
            <div style={{ marginBottom: '20px' }}>
              <span style={{ fontWeight: '700', color: '#334155', fontSize: '11px', textTransform: 'uppercase' }}>Report Remarks / Comments</span>
              <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '10px 14px', marginTop: '4px', color: '#475569', fontSize: '11px' }}>
                <p style={{ margin: 0 }}>{Comment}</p>
              </div>
            </div>
          )}

          {/* Doctor Signatures */}
          {DRS.length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(DRS.length, 3)}, 1fr)`, gap: '16px', marginBottom: '20px', textAlign: 'center' }}>
              {DRS.map((doc, idx) => (
                <div key={idx} style={{ padding: '8px', borderTop: '1px dashed #cbd5e1' }}>
                  <div style={{ fontWeight: '700', color: '#0f172a' }}>{doc.drname}</div>
                  <div style={{ color: '#0284c7', fontSize: '10px', fontWeight: '500' }}>{doc.designation}</div>
                  <div style={{ color: '#64748b', fontSize: '10px' }}>{doc.description}</div>
                </div>
              ))}
            </div>
          )}

          {/* Print Metadata & Copyright */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#94a3b8', fontSize: '10px', borderTop: '1px solid #f1f5f9', paddingTop: '12px' }}>
            <div>
              <span><strong>Printed At:</strong> {formattedCurrentDate}</span> &bull; <span><strong>Printed By:</strong> {username || 'System'}</span>
            </div>
            <div>
              &copy; {new Date().getFullYear()} <strong>{LabName}</strong>. All rights reserved.
            </div>
          </div>
        </footer>

      </div>
    </div>
  );
};

export default Template4;